import { render, staticRenderFns } from "./Tnbt.vue?vue&type=template&id=4787a656&scoped=true&"
import script from "./Tnbt.vue?vue&type=script&lang=js&"
export * from "./Tnbt.vue?vue&type=script&lang=js&"
import style0 from "./Tnbt.vue?vue&type=style&index=0&id=4787a656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4787a656",
  null
  
)

export default component.exports